import * as React from "react";
import { forwardRef } from "react";
const SvgOverviewPerspective = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M7.583 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-.4zM7.583 10a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V10zM4.333 5.417h-3.25A1.084 1.084 0 0 1 0 4.333v-3.25A1.084 1.084 0 0 1 1.083 0h3.25a1.084 1.084 0 0 1 1.084 1.083v3.25a1.084 1.084 0 0 1-1.084 1.084zm-3.25-4.334v3.25h3.25v-3.25h-3.25zM4.333 13h-3.25A1.084 1.084 0 0 1 0 11.917v-3.25a1.084 1.084 0 0 1 1.083-1.084h3.25a1.084 1.084 0 0 1 1.084 1.084v3.25A1.084 1.084 0 0 1 4.333 13zm-3.25-4.333v3.25h3.25v-3.25h-3.25z" }));
const ForwardRef = forwardRef(SvgOverviewPerspective);
export default ForwardRef;
